module.exports = __webpack_public_path__ + "img/moon-over-sun.e1722a50.svg";